import { createElement, type SVGProps } from 'react'
import {
  Briefcase01Icon,
  JobSearchIcon,
  Store01Icon,
  UserCircle02Icon,
  UserGroupIcon,
} from '@hugeicons/core-free-icons'
import type { IconSvgElement } from '@hugeicons/react'

/**
 * The entity-type glyphs an `Avatar` draws, as raw hugeicons data. `NAVIGATION_ICONS` builds its matching entries
 * from these same values, so an icon swapped here changes both places.
 */
export const PROFILE_TYPE_ICON_SVGS = {
  applicant: UserCircle02Icon,
  job: Briefcase01Icon,
  offer: JobSearchIcon,
  team: UserGroupIcon,
  market: Store01Icon,
} as const satisfies Record<string, IconSvgElement>

/**
 * Draws a hugeicon exactly as `NAVIGATION_ICONS` does (`HugeiconsIcon` at strokeWidth 2) without importing
 * `HugeiconsIcon` or navigation-config. The avatar is on the landing, and those two modules added two chunks and two
 * waterfall steps there for icons the landing never draws. The markup is identical (a unit test compares them).
 * The free stroke-rounded set has no two-tone paths, so this skips `HugeiconsIcon`'s opacity sort and colour split.
 */
export function ProfileTypeIcon({ icon, ...props }: SVGProps<SVGSVGElement> & { icon: IconSvgElement }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      color="currentColor"
      className=""
      strokeWidth={2}
      stroke="currentColor"
      {...props}
    >
      {icon.map(([tag, attrs]) =>
        createElement(tag, { ...attrs, strokeWidth: 2, stroke: 'currentColor', key: attrs.key }),
      )}
    </svg>
  )
}
